import React from "react";
import N3BundlesInfo from "./N3BundlesInfo";

export default function N3BundlesPRoduct({ productdetail, data, onCloseHandler }: any) {
  return (
    <div>
      <div className="free-shipping-bundles">
        Free Shipping on all N3 Elite Packages!
      </div>
      <div className="n3-elite-bundles-container">
        <div className="n3-elite-bundles-wrapper">
          <h1>{data.title}</h1>
          <div className="n3-desp-wrapper">
            <p>{data.description}</p>
          </div>
        </div>
      </div>
      <div className="n3-products-container">
        <div className="n3-products-row">
          {productdetail &&
            productdetail?.product_bundles &&
            productdetail.product_bundles?.length > 0 &&
            productdetail.product_bundles?.map((item, index) => (
              <N3BundlesInfo key={index} item={item} onCloseHandler={onCloseHandler} />
            ))}
        </div>
      </div>
    </div>
  );
}
